import React, { useEffect, useState } from "react";
import CustomComonent from "./CustomComonent";
import userResources from "api/userResources";

export default function AirlineSales() {
  const [airlinesData, setAirlinesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchAirline, setSearchAirline] = useState("");

  const getairLinesValue = (value) => {
    setSearchAirline(value);
  };

  const getairLines = async (airline) => {
    setIsLoading(true); // Set loading state to true when fetching starts
    try {
      const response = await userResources.airlines(0, 10, "", airline);
      const data = response.data.data.map((item) => ({
        value: item.id,
        label: item?.airline_code + " " + item?.airline_name, // Use item.airline_name if it exists
      }));

      setAirlinesData(data);
    } catch (error) {
      console.error("Error fetching airline data:", error);
    } finally {
      setIsLoading(false); // Set loading state to false when fetching ends
    }
  };

  useEffect(() => {
    getairLines(searchAirline);
  }, [searchAirline]);

  useEffect(() => {
    getairLines();
  }, []);
  return (
    <div>
      <CustomComonent
        airlineSales={{
          airline: true,
          airlineData: airlinesData,
          airlineLoading: isLoading,
          getairLinesValue: getairLinesValue,
        }}
      />
    </div>
  );
}
